import { useCallback, useEffect, useState } from "react"

const KEY = "zplanem:lastPropertyId"

function readStoredId(): string | null {
	if (typeof window === "undefined") return null
	try {
		return window.localStorage.getItem(KEY)
	} catch {
		return null
	}
}

function writeStoredId(id: string | null) {
	if (typeof window === "undefined") return
	try {
		if (id === null) {
			window.localStorage.removeItem(KEY)
		} else {
			window.localStorage.setItem(KEY, id)
		}
	} catch {
		// localStorage unavailable (private mode, quota) — silently drop
	}
}

export function useLastPropertyId() {
	const [lastPropertyId, setLastPropertyIdState] = useState<string | null>(() =>
		readStoredId(),
	)

	const setLastPropertyId = useCallback((id: string | null) => {
		writeStoredId(id)
		setLastPropertyIdState(id)
	}, [])

	// Keep in sync across tabs.
	useEffect(() => {
		if (typeof window === "undefined") return
		const onStorage = (e: StorageEvent) => {
			if (e.key === KEY) {
				setLastPropertyIdState(e.newValue)
			}
		}
		window.addEventListener("storage", onStorage)
		return () => window.removeEventListener("storage", onStorage)
	}, [])

	return { lastPropertyId, setLastPropertyId }
}
